import React, { useEffect, useState, useRef } from "react";
import { loadApi } from "services/appApi";
import moment from "moment";
import ShowLineWaitTimeChart from "pages/charts/LineWaitChart/ShowLineWaitTimeChart.jsx";
import "primeicons/primeicons.css";
import "assets/css/charts_form_controls.css";
import { Toast } from "primereact/toast";
import axios from "axios";

function LineWaitTimeFormControlListSelector(props) {
  const [processId, setProcessId] = useState();
  const [processLineId, setProcessLineId] = useState();
  const [lines, setLines] = useState([]);
  const [selectedLine, setSelectedLine] = useState();
  const [filteredLines, setFilteredLines] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  const [chartData, setChartData] = useState([]);
  const [targetEfficiency, setTargetEfficiency] = useState();
  const [wasDataFetchingSuccessful, setWasDataFetchingSuccessful] =
    useState(true);
  const [error, setError] = useState(false);
  const [errorStatus, setErrorStatus] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');
  const [flag, setFlag] = useState('');
  const [nFlagErrorMsg, setnFlagErrorMsg] = useState('');
  const [chartForm, setChartForm] = useState([]);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [hasAttemptedFetch, setHasAttemptedFetch] = useState(false);
  const [machineRenderedAsRadio, setMachineRenderedAsRadio] = useState(false);
  const [processRenderedAsRadio, setProcessRenderedAsRadio] = useState(false);
  const [lineRenderedAsRadio, setLineRenderedAsRadio] = useState(false);
  const toast = useRef(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const firstRowProcessId = props.processes[0].id;
        setProcessId(firstRowProcessId);
        console.log(firstRowProcessId);

        const filteredLines = props.lines.filter(
          (data) => data.process_id === firstRowProcessId
        );
        console.log(filteredLines);
        console.log(props.lines);
        setLines(filteredLines);
        setProcessLineId(
          filteredLines.length > 0 ? filteredLines[0].process_id : null
        );
        setSelectedLine(filteredLines.length > 0 ? filteredLines[0].line_number : null);
        const yesterday = moment().subtract(1, "days").set({
          hour: 7,
          minute: 0,
          second: 0,
          millisecond: 0,
        });

        let formattedStartDate = yesterday.format("yyyy-MM-DD HH:mm");
        setStartDate(formattedStartDate);

        const tomorrow = moment().add(0, "days").set({
          hour: 6,
          minute: 59,
          second: 0,
          millisecond: 0,
        });
        let formattedEndDate = tomorrow.format("yyyy-MM-DD HH:mm");
        setEndDate(formattedEndDate);

        setMachineRenderedAsRadio(filteredLines.length <= 2);
        setLineRenderedAsRadio(filteredLines.length <= 2);
        setProcessRenderedAsRadio(props.processes.length <= 2);
      } catch (err) {
        console.log(err);
      }
    };

    fetchData();
  }, [props.processes, props.lines]);

  const handleLoadChart = async () => {
    // console.log(lines);
    let selectedLinesRec = props.lines.find((dt) => dt.line_number == selectedLine);
    let selectedProcessRec = props.processes.find((dt) => dt.id == processId);
    console.log("selected processes", selectedProcessRec);
    console.log(processId);
    console.log(selectedLinesRec);
    if (!selectedLinesRec) {
      setError(true);
      return;
    }

    const p_param = {
      p_process_id: processId,
      p_process_description: selectedProcessRec.description,
      p_line_number: selectedLinesRec.line_number,
      p_start_datetime: startDate,
      p_end_datetime: endDate,
    };
    console.log(p_param);

    setIsLoading(true);
    setHasAttemptedFetch(true); 
    setChartForm({
      ...chartForm,
      p_param,
    });
    console.log(chartForm);
    await loadApi(p_param, "/api/chart/getProcLineWaitTime")
      .then(async (result) => {
        //    await loadApi(p_param, "GetHourlyMachineEffOpTimeByIdAndTimespan").then(async (result) => {
        if (result) {
          console.log("Result: ",result);
          let successFlag = result.data[0];
          setFlag(successFlag);
          console.log("result", result);
          if (successFlag === "Y") {
            if (result.data[1].length > 0) {
              toast.current.show({
            severity: 'success',
            summary: 'Success',
            detail: 'Data fetched successfully'
          })
              setChartData(result.data[1]);
              console.log("result.data[1]", result.data[1]);

              setWasDataFetchingSuccessful(false);
              setError(false);
            } else {
              setErrorStatus(204);
              setError(true);
              setWasDataFetchingSuccessful(true);
            }
          } else {
            setError(true);
            if(result.data[2] && result.data[2].length > 0){
              const extractedErrMsg = result.data[2].map((item) => item.error_msg);
              setnFlagErrorMsg(extractedErrMsg);
            }
          }
          setIsLoading(false);
        } else {
          setWasDataFetchingSuccessful(true);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        if(axios.isCancel(err) || err.name== 'CanceledError') {
        console.log("Request was cancelled by the user.");

        toast.current.show({
          severity: 'warn',
          summary: 'Cancelled',
          detail: 'Request successfully cancelled by the user.',
          life: 3000,
        })
        setIsLoading(false);
      } else {
        console.error(err);
        setErrorStatus(err.response ? err.response.status : null);
        setErrorMessage(err.message)
        setIsLoading(false);
        setError(true);
      }
      });
  };

  const handleProcessChange = (e) => {
    const selectedProcessId = e.target.value;
    setProcessId(selectedProcessId);
    console.log("selectedProcessId", selectedProcessId);

    const filteredLines = props.lines.filter(
      (dt) => dt.process_id == selectedProcessId
    );
    console.log(filteredLines);
    setLines(filteredLines);
    console.log(lines);
    console.log(props.lines);
    setMachineRenderedAsRadio(filteredLines.length <= 2);
    setLineRenderedAsRadio(filteredLines.length <= 2);
    setProcessLineId(
      filteredLines.length > 0 ? filteredLines[0].process_idid : null
    );
    setSelectedLine(filteredLines.length > 0 ? filteredLines[0].line_number : null);
  };

  /*const handleLineChange = (e) => {
    const selectedLines = e.target.value;
    setFilteredLines(selectedLines);
  };*/
  const handleLineChange = (e) => {
    const selectedLines = e.target.value;
    setSelectedLine(selectedLines);
    setFilteredLines(selectedLines);
    console.log('Selected machine number:', e.target.value);
    
  };


  const handleStartDateChange = (e) => {
    setStartDate(e.target.value);
  };

  const handleEndDateChange = (e) => {
    setEndDate(e.target.value);
  };

    const getProcessControl = () => (
        <React.Fragment>
        <div className="col-auto px-1">
        <label
          className={
            props.processes.length === 1 ? "form-label mb-3" : "form-label"
          }
        >
          Process
        </label>
          {processRenderedAsRadio ? (
            <div className="form-check">
              {props.processes.map((input) => (
                <div key={input.id}>
                  <input
                    inputId={`${props.chartId}ProcessRadBtn${input.id}`}
                    className="form-check-input"
                    type="radio" 
                    name={`${props.chartId}ProcessRadBtn`}
                    value={input.id}
                    onChange={handleProcessChange}
                    checked={processId == input.id}
                    disabled={isLoading}
                  />
                  <label
                    className="form-check-label"
                    htmlFor={`${props.chartId}ProcessRadBtn${input.id}`}
                  >
                    {input.description}
                  </label>
                </div>
              ))}
            </div>
          ) : (
            <select
              className="form-select"
              id={`${props.chartId}ProcessDrpDnList`}
              name={`${props.chartId}ProcessDrpDnList`}
              onChange={handleProcessChange}
              value={processId || ""}
              disabled={isLoading}
            >
              {props.processes.map((option) => (
                <option key={option.id} value={option.id}>
                  {option.description}
                </option>
              ))}
            </select>
          )}
        </div>
      </React.Fragment>
    );
        const getLineControl = () =>(
       <React.Fragment>
            <div className="col-auto px-1">
            <label
              className={
                lines.length === 1 ? "form-label mb-3" : "form-label"
              }
            >
              Lines
            </label>
              {lineRenderedAsRadio ? (
              <div className="form-check" onChange={handleLineChange}>
              {lines.map((input) => (
                <div key={input.line_number}>
                  <input
                    className="form-check-input"
                    type="radio"
                    id={`${props.chartId}LinesRadBtn${input.line_number}`}
                    name={`${props.chartId}LinesRadBtn`}
                    value={input.line_number}
                    onChange={handleLineChange}
                    checked={selectedLine == input.line_number}
                    disabled={isLoading}
                  />
                  <label
                    className="form-check-label"
                    htmlFor={`${props.chartId}LinesRadBtn${input.line_number}`}
                  >
                    {input.line_number}
                  </label>
                </div>
              ))}
            </div>
              ) : (
                <select
                  className="form-select"
                  id={`${props.chartId}LineDrpDnList`}
                  name={`${props.chartId}LineDrpDnList`}
                  onChange={handleLineChange}
                  value={selectedLine || ""}
                  disabled={isLoading}
                >
                  {lines.map((option) => (
                    <option key={option.line_number} value={option.line_number}>
                      {option.line_number}
                    </option>
                  ))}
                </select>
              )}
            </div>
          </React.Fragment>
      );

  const getStartEndDateControls = () => (
      <React.Fragment>
        <div className="col-auto px-1">
          <div className="row justify-content-center m-0">
            <div className="col-auto form-group ps-0 pe-1 width-sm-auto">
          <label className="form-label">Start Date</label>
          <div className="input-group date input-wrapper">
          <input
            type="datetime-local"
            id={props.chartId + "StartDateTime"}
            name={props.chartId + "StartDateTime"}
            defaultValue={startDate}
            onChange={handleStartDateChange}
            className="input-outline1"
            disabled={isLoading}
          />
          </div>
        </div>
        <div className="col-auto form-group ps-1 pe-0 width-sm-auto">
          <label className="form-label">End Date</label>
          <div className="input-group date input-wrapper">
          <input
            type="datetime-local"
            id={props.chartId + "EndDateTime"}
            name={props.chartId + "EndDateTime"}
            defaultValue={endDate}
            onChange={handleEndDateChange}
            className="input-outline1"
            disabled={isLoading}
          />
          </div>
        </div>
        </div>
        </div>
      </React.Fragment>
    );

  const getLoadButtonControl = () => (
     <React.Fragment>
         <div className="col-auto px-1" style={{paddingTop:'31px'}}>
         <button type="button" id={props.chartId + "chartAreaId"} className="btn btn-primary" onClick={handleLoadChart}
             disabled={isLoading}><i
             className={
               isLoading ? "fa-duotone fa-fw fa-rotate fa-spin" : "fa-duotone fa-fw fa-rotate"
             }
           ></i>{" "}
           <span>{isLoading ? "Loading" : "Load"}</span></button>
         </div>
     </React.Fragment>
   );

  return (
    <div className="col mx-2">
       <Toast ref={toast} />
    <div className="row">
      <div className="col">
    <div className="row justify-content-center">
        {getProcessControl()}
        {getLineControl()}
        {getStartEndDateControls()}
        {getLoadButtonControl()}
      </div> 
      
      {error && hasAttemptedFetch &&  (
         <div className="row mt-5 justify-content-md-center">
          <div className="col-6">
            <div className="card border-secondary">
              <div className="card-header bg-dark text-white">
                  {errorStatus === 204 && (
                    <h3>No Matching Results!</h3>
                  )}
                  {errorStatus === 500 && (
                    <h3>Data/export unavailable</h3>
                  )}
                  {errorStatus && ![204, 500].includes(errorStatus) && (
                    <h3>Unable to Pull Chart Data</h3>
                  )}
                  {flag === "N" && (
                    <h3>No Matching Results!</h3>
                  )}
              </div>
              <div className="card-body card-body-error rounded-bottom">
                  {/* Conditional rendering based on error status */}
                  {errorStatus === 204 && (
                    <h6 style={{fontWeight:"normal"}}>There are no results found.</h6>
                  )}
                  {errorStatus && ![204].includes(errorStatus) && (
                    <>
                    <h5>Charts were not loaded due to...</h5>
                    <ul class="mb-0">
                    <li>
                      {errorMessage}
                    </li>
                  </ul>
                  </>
                  )}
                  {flag === "N" && (
                    <ul class="mb-0" style={{listStyleType: 'none', padding: 0, margin: 0}}>
                      {nFlagErrorMsg.map((error_msg, index) => (
                        <li key={index}>
                          {error_msg}
                        </li>
                      ))}   
                  </ul>
                  )}
              </div>
            </div>
          </div>
        </div>
      )}
      {!wasDataFetchingSuccessful && !error && (
        <div className="row my-3">
          <div className="col mx-2">
              <ShowLineWaitTimeChart
                chartData={chartData}
                chartForm={chartForm}
                id={props.chartId + "Pareto Chart1"}
              />
            </div>
          </div>
      )}
    </div>
    </div>
    </div>
  );
}

export default LineWaitTimeFormControlListSelector;
